import React from "react"
import Typography from "aldoo-ra/Typography"
import CMSRender from "aldoo-ra/CMS/cms-render"

/**
 * Request Link Component
 * Displays a "Submit a request" link with an icon
 */
const RequestLink = () => {
  return (
    <CMSRender
      contentType="HCRequestLink"
      renderItem={(data) => {
        return (
          <div className="w-auto min-w-[310px] max-w-fit md:h-[68px] flex flex-col md:flex-row flex-none justify-center items-center bg-gray_100 rounded-[40px] gap-2 px-5 py-5 md:py-0 mx-auto">
            <img src={data.icon} className="w-6 h-6 mr-[2px]" />

            <Typography variant="body1" className="my-0">
              {data.text}
            </Typography>

            <Typography variant="body1" className="my-0">
              <a
                href="/help-center/submit-request"
                className="text-primary underline font-bold"
              >
                {data.cta}
              </a>
            </Typography>
          </div>
        )
      }}
    />
  )
}

export default RequestLink
